import { Injectable, OnInit } from "@angular/core";

@Injectable()
export class CatParametroGrupos {
    public id: number;
    public descripcion: string;
    public baja: boolean = false;
    public cambio: boolean = false;
    public numRow: number;
} 

@Injectable()
export class Aguas {
    public id: number;
    public cuentaAgua: number;
    public derivada: number;
    public cuentaAguaAnterior: string;
    public idUsuarioGuardo: number;
    public fechaAlta: Date;
    public fechaBaja: Date;
    public idEstatus: number;
    public idAguaZona: number;
    public idTipoServicio: number;
    public idTipoToma: number;
    public idTipoUso: number;
    public idTipoConsumo: number;
    public fechaUltimoPago: Date;
    public idTipoPeriodoUp: number;
    public periodoAnioUp: number;
    public periodoParcialidadUp: number;
    public porcentajeConstruccion: number;
    public observaciones: string;
    public idDiametroToma: number;
    public IdDiametroDrenaje: number;
    public fechaCorte: Date;
    public idSolicitudDetalle: number;
    public cveMun: number;
    public cveZona: number;
    public cveLoc: number;
    public cveSec: number;
    public cveManz: number;
    public cveLote: number;
    public cveEdif: string;
    public cveDepto: string;
    public cuentaPredial: number;
    public tpPredial: string;
    public domicilio: string;
    public numeroLocal: string;
    public nombreLocal: string;
    public idCalle: number;
    public idMunicipio: number;
    public idColonia: number;
    public numExteror: string;
    public numInterior: string;
    public superficieConstruccion: number;
    public idTipoGiro: number;
    public idRuta: number;
    public esCumplido: boolean;
    public idCalleColinda1: number;
    public idCalleColinda2: number;    
    public dato: string;
    public consecutivo: number;
    public idDelegacion: number;
    public idTipoContrato: number;
    public cveCatastral: number;
}

@Injectable()
export class CatAguaZonas {
    public id: number;
    public descripcion: string;
    baja: any;
    cambio: boolean;
    public numRow: number;
}


@Injectable()
export class CatUsuarios {
    public numRow: number;
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public nombreUsuario: string;
    public nombre: string;
    public primerApellido: string;
    public segundoApellido: string;
    public telefono: string;
    public correoElectronico: string;
    public fechaAlta: Date;
    public fechaBaja: Date;
    public idEstatus: number;
    public contrasenia: string;
    public idDireccion: number;
    public idDepartamento: number;
    public idCargo: number;
    public token: string;
    public idSucursal: number;
    public sesionActiva: boolean;
    public fechaApertura: Date;
    public info: string;
    public fechaCambioContrasenia: Date;
    public nombreUsuarioCompleto: string;
    public idDireccionDepartamento: number;
    public datosadicionales: string;
    public direccionDepartamentoDescripcion: string;
    public catDireccionesDepartamentos: any[] = [];
    public cuadrilla: string;
    public fechaCambio: string;

}

@Injectable()
export class CatEstatus {
    public id: number;
    public descripcion: string;
    public baja: boolean = false;
    public cambio: boolean = false;
    public numRow: number;
}

@Injectable()
export class CatTipoServicios {
    public id: number;
    public descripcion: string;
    cambio: boolean;
    baja: any;
    public numRow: number;
    public abreviatura: string;
}

@Injectable()
export class CatTipoConsumos {
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public descripcion: string;
    public numRow: number;
}
@Injectable()
export class CatDiametroTomas {
    public id: number;
    public descripcion: string;
    public baja: boolean = false;
    public cambio: boolean = false;
    public numRow: number;
}

@Injectable()
export class Solicitudes {
    public id: number;
    public idAgua: number;
    public idPersonaPropietario: number;
    public idPersonaCliente: number;
    public idEstatus: number;
    public idUsuarioSolicito: number;
    public fechaSolicitud: Date;
    public observaciones: string;
    public numSolicitud: number;
    public idMunicipioIncidente: number;
    public idColoniaIncidente: number;
    public idCalleIncidente: number;
    public entreCalle1: string;
    public entreCalle2: string;
    public numeroExteriorIncidente: string;
    public numeroInteriorIncidente: string;
    public referenciaIncidente: string;
    public idCobro: number;
    public idEtapasTramite: number;
    public idConcepto: number;
    public nombre: string;
    public direccion: string;
    public colonia: string;
    public telefono: number
    public medidor: string;
    public idViaAtencion: number;
    public CuentaAgua: number;
    public zonaOrdenes: string;
    public dato: string;
    public telefonoOrdenes: string;
}

@Injectable()
export class CatCalles {
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public descripcion: string;
    public idColonia: number;
    public numRow: number;
}

@Injectable()
export class CatColonias {
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public descripcion: string;
    public idZona: number;
    public idDelagacion: number;
    public numRow: number;
}

@Injectable()
export class CatTipoGiros {
    public numRow: number;
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public descripcion: string;
    public idTipoConsumo: number;

}

@Injectable()
export class User {
    id: number;
    username: string;
    password: string;
    firstName: string;
    lastName: string;
    token?: string;
}

@Injectable()
export class Personas {
    public id: number;
    public razonSocial: string;
    public nombre: string;
    public primerApellido: string;
    public segundoApellido: string;
    public numexterior: string;
    public numinterior: string;
    public idcalle: number;
    public idcolonia: number;
    public idmunicipio: number;
    public idestado: number;
    public correoelectronico: string;
    public correoelectronico2: string;
    public rfc: string;
    public telefono: string;
    public telefono2: string;
    public idtipopersona: number;
    public folioidentificacion: string;
    public fechanacimiento: Date;
    public baja: boolean = false;
    public cambio: boolean = false;
    public descripcion: string;
    public idRegimenFiscal: number;
    public cp: number;
    public idTipoDocuemnto: number;
    public vencimiento: Date;
    public domicilio: string;
    public direccionEnvio: string;
}

@Injectable()
export class CatTipoContratoPersonas {
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public descripcion: string;
    public numRow: number;
}

@Injectable()
export class CatTipoPersonas {
    public id: number;
    public descripcion: string;
    cambio: boolean;
    baja: any;
    public numRow: number;
}

@Injectable()
export class CatMunicipios {
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public idEstado: number;
    public descripcion: string;
    public numRow: number;
}

@Injectable()
export class CampoCedulas {
    public id: number;
    public descripcion: string;
    public fecha: Date;
    public domicilio: string;
    public idaguazona: number;
    public idtiposervicio: number;
}
@Injectable()
export class AguaBuscaCuentas {
    public id: number;
    public cuentaAguaAnterior: string;
    public cuentaAgua: number;
    public derivada: number;
    public cuentaPredial: number;
    public domicilio: string;
    public colonia: string;
    public cveCatastral: string;
    public cveMun: number;
    public cveZona: number;
    public cveManz: number;
    public cveLote: number;
    public cveEdif: string;
    public cveDepto: string;
    public cliente: string;
    public razonSocial: string;
    public nombre: string;
    public primerApellido: string;
    public segundoApellido: string;
    public serie: string;
    public idTipoServicio: string;
    public idTipoUso: string;
    public idRuta: string;
    public idTipoPeriodo: number;
    public nombreLocal: string;
    public delegacion: string;
    public calle: string;
    public consecuti: number;
    
}
@Injectable()
export class RAguasPersonas {
    public id: number;
    public idTipoContratoPersona: number;
    public idAgua: number;
    public idPersona: number;
    public idSolicitud: number;
    public idUsuarioGuardo: number;
    public fechaAlta: Date;
    public idEstatus: number;
    public personas: Personas;
}

@Injectable()
export class MedioPagos {
    public id: number;
    public idCobro: number;
    public idBanco: number;
    public idMedioPago: number;
    public monto: number;
    public referencia: string;
    public fechaDeposito: Date;
    public autorizacionTarjeta: string;
    public esAbono: boolean;
}
@Injectable()
export class Cobros {
    public id: number;
    public idAgua: number;
    public cuentaAgua: number;
    public idUsuarioCobro: number;
    public fechaPago: Date;
    public idUsuarioCancela: number;
    public fechaCancelacion: Date;
    public idMotivoCancelacion: number;
    public idEstatus: number;
    public nombreEnRecibo: string;
    public domicilioEnRecibo: string;
    public serie: string;
    public folio: number;
    public total: number;
    public totalLetra: string;
    public rfc: string;
    public idCorte: number;
    public observaciones: string;
}

@Injectable()
export class CatBancos {
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public descripcion: string;
    public numRow: number;
}

@Injectable()
export class CatMedioPagos {
    public id: number;
    public descripcion: string;
    public requiereFechaDeposito: string;
    public requiereBanco: string;
    public orden: number;
    public baja: boolean = false;
    public cambio: boolean = false;
    public clave: string;
    public numRow: number;
}

@Injectable()
export class CatTipoPeriodos {
    public id: number;
    public descripcion: string;
    public baja: boolean = false;
    public cambio: boolean = false;
    public numRow: number;
}

@Injectable()
export class CatRutas {
    public id: number;
    public descripcion: string;
    public dato:string;
    public fechaCorte: Date;
    public numRow: number;
}

@Injectable()
export class Medidores {
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public serie: string;
    public idUbicacionMedidor: number;
    public idTipoMedidor: number;
    public idEstadoFuncionamiento: number;
    public idEstatus: number;
    public fechaIni: Date;
    public fechaFin: Date;
    public idUsuarioInstalo: number;
    public idSolicitudDetalle: number;
    public idAgua: number;
    public consecutivo: number;
    public lecturaAnt: number;
    public observaciones: string;
    public fechaInstalacion: Date;
    public fechaDesinstalacion: Date;

}

@Injectable()
export class MedidoresDTO {
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public serie: string;
    public idUbicacionMedidor: number;
    public idTipoMedidor: number;
    public idEstadoFuncionamiento: number;
    public idEstatus: number;
    public fechaIni: Date;
    public fechaFin: Date;
    public idUsuarioInstalo: number;
    public idSolicitudDetalle: number;
    public idAgua: number;
    public consecutivo: number;
    public lecturaAnt: number;
}

@Injectable()
export class CatUbicacionMedidores {
    public id: number;
    public descripcion: string;
    public baja: boolean = false;
    public cambio: boolean = false;
    public numRow: number;
}

@Injectable()
export class CatTipoMedidores {
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public descripcion: string;
    public modelo: string;
    public material: string;
    public idMarcaMedidor: number;
    public pulgadas: number;
    public numRow: number;
}

@Injectable()
export class CatEstadoFuncionamientos {
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public descripcion: string;
    public numRow: number;
}
@Injectable()
export class Descuentos {
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public id_cargo: number;
    public descripcion: string;
    public monto: number;
    public id_concepto: number;
}
@Injectable()
export class CargosDetalles {
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public idAgua: number;public cuentaAgua: number;
    public idTipoPeriodo: number;
    public tipoPeriodo: string;
    public anio: number;
    public periodoParcialidad: number;
    public periodoIni: Date;
    public lecturaIni: number;
    public lecturaFin: number;
    public consumos: number;
    public anomalia: string;
    public idCargo: number;
    public base: number;
    public idBaseIva: number;
    public baseIva: number;
    public idDrenaje: number;
    public drenaje: number;
    public idDrenajeIva: number;
    public drenajeIva: number;
    public idManejo: number;
    public manejo: number;
    public idManejoIva: number;
    public manejoIva: number;
    public concepto: string;
    public idServicios: number;
    public servicios: number;
    public idServiciosIva: number;
    public serviciosIva: number;
    public idActualizacion: number;
    public actualizacion: number;
    public idRecargos: number;
    public recargos: number;
    public descVulnerable: number;
    public idDescVulnerableAg: number;
    public descVulnerableAg: number;
    public idDescVulnerableDr: number;
    public descVulnerableDr: number;
    public descAguaEne: number;
    public idDescAguaEneAg: number;
    public descAguaEneAg: number;
    public idDescAguaEneDr: number;
    public descAguaEneDr: number;
    public descAguaEneCump: number;
    public idDescAguaEneCumpAg: number;
    public descAguaEneCumpAg: number;
    public idDescAguaEneCumpDr: number;
    public descAguaEneCumpDr: number;
    public descAguaFeb: number;
    public idDescAguaFebAg: number;
    public descAguaFebAg: number;
    public idDescAguaFebDr: number;
    public descAguaFebDr: number;
    public descAguaFebCump: number;
    public idDescAguaFebCumpAg: number;
    public descAguaFebCumpAg: number;
    public idDescAguaFebCumpDr: number;
    public descAguaFebCumpDr: number;
    public descAguaMar: number;
    public idDescAguaMarAg: number;
    public descAguaMarAg: number;
    public idDescAguaMarDr: number;
    public descAguaMarDr: number;
    public idDescRec100: number;
    public descRec100: number;
    public idDescRec75: number;
    public descRec75: number;
    public idDescRec50: number;
    public descRec50: number;
    public idDescMul100: number;
    public descMul100: number;
    public idDescMul75: number;
    public descMul75: number;
    public idDescMul50: number;
    public descMul50: number;
    public idConvenio: number;
    public convenios: number;
    public idIntCon: number;
    public interesCon: number;
    public idInteresMoraCon: number;
    public interesMoraCon: number;
    public idGasto: number;
    public gasto: number;
    public idMulta: number;
    public multa: number;
    public idCargoPendiente: number;
    public cargoPendiente: number;
    public importe: number;
    public descuento: number;
    public idRedondeoRezago: number;
    public redondeoRezago: number;
    public idRedondeo: number;
    public redondeo: number;
    public total: number;
    public acumulado: number;
    public fechaCobro: Date;
    public estatus: string;
    public selected: boolean;
    public Fijar: boolean;
    public idEstatus: number;
    public conceptoBase: number;
    public cajero: string;
    public caja: string;
    public folio: string;
    public medio: string;
    public totalFacturado: number;
    public idInfra: number;
    public infraIva: number;
    public idInfraIva: number;
    public infra: number;
    public descuentosJson: string;
    public validacionremul: boolean;
    public validacion: string;
    public fechaLectura: Date;
    public tarifa: string;
    public fechaVencimiento: Date;
    public observacionesCobro: string;
    public fechafacturacion: string;
}
@Injectable()
export class CargosDetallesInput {
    public idAgua: number;
    public cuentaAgua: number;
    public periodoIni: Date;
    public periodoFin: Date;
    public idTipoPeriodo: number;
    public idEstatus: number;
    public fechaCalculos: Date;
    public idUsuarioGuardo: number;
    public conEstimadoAnual: boolean;
    public ejecutaCalculo: boolean;
    public borrarEstimado: boolean;
    public conConvenio: boolean;
    public conCargo: boolean;
    public esAbono: boolean;
    public parametrosAdicionales: string = null;
}
@Injectable()
export class DatosCfdiFacturas {
    public id: number;
    public folio: number;
    public serie: string;
    public nombreR: string;
    public domicilioR: string;
    public rfcR: string;
    public fechaPago: Date;
    public cajero: string;
    public descripcion: string;
    public cfdiSchemaLocation: string;
    public cfdiXslt: string;
    public cfdiNumVersion: string;
    public cfdiFechaFacturacion: Date;
    public cfdiFormaPagoSpecified: boolean;
    public cfdiCondicionesDepago: string;
    public cfdiMoneda: string;
    public cfdiTipoCambio: number;
    public cfdiTipocambioSpecified: boolean;
    public cfdiTotal: number;
    public cfdiTotalLetra: string;
    public cfdiTipoDeComprobante: string;
    public cfdiMetodoPago: string;
    public cfdiMetodoPagoSpecified: boolean;
    public cfdiMetodoPagoClave: string;
    public cfdiAddenda: string;
    public cfdiCfdiRelacionados: string;
    public cfdiDescuentoSpecified: boolean;
    public cfdiImpuestos: number;
    public cfdiTotalPagar: number;
    public cfdiUuid: string;
    public cfdiComprobanteXml: string;
    public cfdiComprobanteXmlString: string;
    public cfdiQrImage: any;
    public cfdiQrArray: any;
    public cfdiPdf: any;
    public emisorNombre: string;
    public emisorRegimenFiscal: string;
    public emisorRfc: string;
    public emisorCp: string;
    public emisorCert: string;
    public emisorCertValor: string;
    public emisorPk: string;
    public emisorKeypk: string;
    public emisorNoCertificado: string;
    public emisorPacUsuario: string;
    public emisorPacPass: string;
    public receptorNombre: string;
    public receptorCorreo: string;
    public receptorResidenciafiscal: string;
    public receptorResidenciafiscalspecified: boolean;
    public receptorRfc: string;
    public receptorUsocfdi: string;
    public domicilioFiscal: string;
    public regimenFiscal: string;
    public idUsoCfdi: number;
    public idRegimenFiscal: number;
    public regimenFiscalDesc: string;
    public idMedioPago: number;

}

@Injectable()
export class AdjuntoFacturacionDocs {
    public nombre: string;
    public adjuntoXml: string;

}

@Injectable()
export class DesgloseFacturas {
    public id: number;
    public idCobro: number;
    public fechaPago: Date;
    public claveprodserv: string;
    public claveunidad: string;
    public concepto: string;
    public cantidad: number;
    public monto: number;
    public descuento: number;
}

@Injectable()
export class CatCfdiUsos {
    public id: number;
    public clave: string;
    public descripcion: string;
    public fisica: boolean;
    public moral: boolean;
    public baja: boolean = false;
    public cambio: boolean = false;
    public numRow: number;
}

@Injectable()
export class PersonaClientes {
    public id: number;
    public razonSocial: string;
    public nombre: string;
    public primerApellido: string;
    public segundoApellido: string;
    public correoElectronico: string;
    public domicilio: string;
    public idEstado: number;
    public idMunicipio: number;
    public idColonia: number;
    public idCalle: number;
    public idEntreCalle: number;
    public idDelegacion: number;
    public numExterior: string;
    public numInterior: string;
    public rfc: string;
    public telefono: string;
    public folioIdentificacion: string;
    public idTipoPersona: number;
    public cp: number;
    public idRegimenFiscal: number;
    public regimenFiscal: string;
    public idAgua: number;
    public cuentaAgua: string;
    public idUsoCfdi: number;
}

@Injectable()
export class FacturacionData {
    public id: number;
    public metodoPago: CatMedioPagos;
    public usoCFDI: CatCfdiUsos;
    public receptor: PersonaClientes;
}

@Injectable()
export class CatConceptos {
public numRow: number;
public baja: boolean = false;
public cambio: boolean = false;
public id: number;
public descripcion: string;
public cuentaContable: string;
public idGrupoConcepto: number;
public idEstatus: number;
public observaciones: string;
public solicitable: boolean;
public fechaIni: Date;
public fechaFin: Date;
public orden: number;
public idGrupoContable: number;
public idClaveProdSer: number;
public idClaveUnidad: number;
public idCuentaCargo: number;
public idCuentaAbono: number;
public idCuentaEjecutar:number;
public idCuentaDevengado : number;
public idCuentaRecaudado : number;  
public reqNomina: boolean;
public calcIva: boolean;
}

@Injectable()
export class CatConceptoCostos {
    public id: number;
    public idConcepto: number;
    public idUnidadMedida: number;
    public idUnidadCobro: number;
    public fechaIni: Date;
    public fechaFin: Date;
    public costoUmas: number;
    public costoPesos: number;
    public costoMinimo: number;
    public costoMaximo: number;
    public baja: boolean = false;
    public cambio: boolean = false;
    public fecha: Date;
    public numRow: number;
}

@Injectable()
export class RConceptosRequisitos {
    public id: number;
    public idRequisito: number;
    public idConcepto: number;
}
@Injectable()
export class CatRequisitos {
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public descripcion: string;
    public numRow: number;
}

@Injectable()
export class BuscaTramite {
    public id: number;
    public cuentaAgua: number;
    public numSolicitud: number;
    public idAgua: number;
    public fecha: Date;
    public solicitante: string;
    public rfcSolicitante: string;
    public emailSolicitante: string;
    public idPcSolicitante: number;
    public estadoTramite: string;
    public concepto: string;
    public estatusPago: string;
    public observaciones: string;
    public domicilio: string;
    public idconcepto: number;
    public idEstadoTramite: number;
    public idEstatus: number;
    public rutaPagina: string;
    public idSolicitudDetalle: number;
    public fechaVigencia: Date;
    public monto: number;
}

@Injectable()
export class BuscaTramiteInput {
    public numSolicitud: number;
    public cuentaAgua: number;
    public fechaDe: Date;
    public fechaHasta: Date;
    public esCaja: boolean;
    public Nombre: string;
    public PApellido: string;
    public SApellido: string;
    public RazonSocial: string;
}

@Injectable()
export class RouteInfo {
    path: string;
    title: string;
    ab?: string;
    type: string;
    collapse?: string;
    icontype?: string;
    children?: RouteInfo[];
}
@Injectable()
export class SolicitudEtapaTramites {
    public id: number;
    public idSolicitud: number;
    public idEtapasTramite: number;
    public fecha: Date;
    public idUsuarioEjecuto: number;
    public idEstatus: number;
    public observaciones: string;
    public idDireccion:  number;
    public idDireccion1: number;
    public idDireccion2: number;
}
@Injectable()
export class CatEtapasTramites {
    public id: number;
    public descripcion: string;
    public rutaPagina: string;
    public baja: boolean = false;
    public cambio: boolean = false;
    public numRow: number;
}

@Injectable()
export class AuxJasper {
    public JasperReport = new JasperReport();
    public ParametroJasper = new Array<ParametroJasper>();
    public esPDF: boolean = false;
}
@Injectable()
export class ParametroJasper {
    public nombre: string;
    public valor: string;
    public idSolicitud: string;
    public idUsuario: number;
    public aniosCalculados: number;

}
@Injectable()
export class JasperReport {
    public urlGeneral: string;
    public usuario: string;
    public constrasenia: string;
    public puerto: string;
    public nombreReporte: string;
    public tipo: string;
    public urlCompleta: string;
    public imprimir: boolean;
}

@Injectable()
export class MonitoreoFlujoTramite {
    public id: number;
    public idSolicitud: number;
    public idSolicitudDetalle: number;
    public estadoTramite: string;
    public fecha: Date;
    public usuario: string;
    public estatus: string;
    public rutaPagina: string;
    public idAgua: number;
}
@Injectable()
export class MonitoreoFlujoTramiteInput {
    public idSolicitud: number;
}
@Injectable()
export class Contratos {
    public id: number;
    public idAgua: number;
    public numContrato: string;
    public fecha: Date;
    public lugar: string;
    public idUsuario: number;
    public firmoContratante: string;
    public domicilioContratante: string;
    public firmoContrato: string;
    public tipoUso: string;
    public tipoServicio: string;
    public jefeAntencion: string;
    public directorGeneral: string;
    public coloniaContratante: string;
    public idSolicitud: string;
}


@Injectable()
export class SolicitudRequisitos {
    public id: number;
    public idRequisito: number;
    public idSolicitud: number;
    public observaciones: string;
    public recibido: boolean;
}

@Injectable()
export class SolicitudDetalles {
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public costoUnitario: number;
    public cantidad: number;
    public monto: number;
    public idSolicitud: number;
    public idConcepto: number;
    public idConceptoCosto: number;
    public idCobroConcepto: number;
    public idPadre: number;
    public idAgua: number;
    public idSolicitudEtapaTramites: number;
    public idEstatus: number;
}

@Injectable()
export class BuscaDetalleSolicitud {
    public id: number;
    public numSolicitud: number;
    public fecha: Date;
    public solicitante: string;
    public estadoTramite: string;
    public concepto: string;
    public estatusPago: string;
    public observaciones: string;
    public domicilio: string;
    public idconcepto: number;
    public idEstadoTramite: number;
    public idEstatus: number;
    public rutaPagina: string;
    public cantidad: number;
    public costoUnitario: number;
    public monto: number;
    public idPersonaCliente: number;
    public total: number;
    public idAgua: number;
}
@Injectable()
export class BuscaDetalleSolicitudInput {
    public numSolicitud: number;
    public id: number;
    public fechaDe: Date;
    public fechaHasta: Date;
}
@Injectable()
export class InfoTramiteInput {
    public idSolicitud: number;
}
@Injectable()
export class InfoTramite {
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public numSolicitud: number;
    public fecha: Date;
    public solicitante: string;
    public observaciones: string;
    public domicilio: string;
    public idPersonaCliente: number;
}
@Injectable()
export class json_in {
    public Cobros_in = new Cobros_in();
    public MedioPagos_in = new Array<MedioPagos_in>();
    public CargosDetalles_in = new Array<CargosDetalles>();
    public Busca_detalle_solicitud_in = new Array<BuscaDetalleSolicitud>();
}

@Injectable()
export class Cobros_in {
    public idAgua: number;
    public idUsuarioCobro: number;
    public total: number;
    public observaciones: string;
    public idConceptoGral: number;
    public idSolicitud: number;
    public esAbono: boolean;
    public conRedondeo: boolean;
}

@Injectable()
export class MedioPagos_in {
    public idBanco: number;
    public idMedioPago: number;
    public monto: number;
    public referencia: string;
    public fechaDeposito: Date;
    public autorizacionTarjeta: string;
}
@Injectable()
export class Cargos_detalles_in {
    public idCargo: number;
}
@Injectable()
export class Busca_detalle_solicitud_in {
    public id: number;
    public numSolicitud: number;
    public fecha: Date;
    public solicitante: string;
    public estadoTramite: string;
    public concepto: string;
    public estatusPago: string;
    public observaciones: string;
    public domicilio: string;
    public idconcepto: number;
    public idEstadoTramite: number;
    public idEstatus: number;
    public rutaPagina: string;
    public cantidad: number;
    public costoUnitario: number;
    public monto: number;
    public idPersonaCliente: number;
}

@Injectable()
export class Cortes {
    public id: number;
    public dotacionInicial: number;
    public fechaApertura: Date;
    public fechaCierre: Date;
    public idUsuarioCajero: number;
    public idSucursal: number;
}

@Injectable()
export class CorteTotalInput {
public fechaDe: Date;
public fechaHasta: Date;
public idUsuario: number;
public idSucursal: number;
}

@Injectable()
export class CorteTotal {
public numRow: number;
public baja: boolean = false;
public cambio: boolean = false;
public id: number;
public total: number;
public remesas: string;
}

@Injectable()
export class CertificadoNoAdeudo {
    public id: number;
    public cuentaAgua: number;
    public cuentaAguaAnterior: string;
    public cuentaPredial: number;
    public fechaUltimoUltimoPago: string;
    public anoUltimoPago: string;
    public propietario: string;
    public domicilioCuentaAgua: string;
    public domicilioPersona: string;
    public uso: string;
    public tipoServicio: string;
    public tipoToma: string;
    public id_usuario: number;
    public _id_solicitud_detalle: number;

}

@Injectable()
export class BuscaPersonaClientes {
    public id: number;
    public razonSocial: string;
    public nombreCliente: string;
    public correoElectronico: string;
    public domicilio: string;
    public rfc: string;
    public telefono: string;
    public folioIdentificacion: string;
    public tipoPersona: string;
    public solicitudPersona: boolean;
    public regimenFiscal: string;
    public cuentaAgua: number;
    public idUsoCfdi: number;
}
@Injectable()
export class CatSucursales {
    public id: number;
    public descripcion: string;
    cambio: boolean;
    baja: any;
    public numRow: number;
}
@Injectable()
export class EstadoCuentaInformacion {
    public idAgua: number;
    public cuentaAgua: number;
    public cuentaAnterior: string;
    public nombreCompleto: string;
    public domicilio: string;
    public cp: string;
    public ruta: number;
    public numeroMedidor: string;
    public fechaInstalacion: Date;
    public claveCatastral: string;
    public rfc: string;
    public periodo: number;
    public tipoPeriodo: string;
    public anio: number;
    public fechaVencimiento: Date;
    public derivada: number;
    public anomalia: string;
    public observaciones: string;
    public diametro: string;
    public tipoServicio: string;
    public proximaLectura: string;
    public tipoUso: string;
    public lecturaIni: number;
    public lecturaFin: number;
    public periodoConsumoIni: Date;
    public periodoConsumoFin: Date;
    public consumo: number;
    public total: number;
    public periodoadeudo: string;
    public numConvenio: number;
    public grupoVulnerable: string;
    public bloqueoVigente: string;
    public estatus: string;
    public fechaAlta: Date;
    public fechaBaja: Date;
    public esCumplido: boolean;
    public cuentaPredial: number;
    public observacionesCuenta: string;
    public folioFicalizacion: number;
    public fechaFicalizacion: Date;
    public tipoDocumento: string;
    public periodoDesdeNotificacion: string;
    public tipoToma: string;
    public nombreLocal: string;
    public direcionEnvio: string;
    public fechaFin: Date;
    public padre: number;
    public conDomic: boolean;
    public tipoProrrateo: string;
    public estadoAnt: string;
    public conServicios: boolean;
}
@Injectable()
export class EstadoCuentaInformacionInput {
    public idAgua: number;
    public cuentaAgua: number;
    public colonia: number;
    public idRuta: number;
    public periodoParcialidad: number;
    public anio: number;
}
@Injectable()
export class BuscaCobros {
    public id: number;
    public folio: string;
    public serie: string;
    public fechaPago: string;
    public importe: number;
    public cuentaAgua: string;
    public cajero: string;
    public condicion: string;
    public uuid: string;
    public estatusCobro: string;
    public estatusFactura: string;
    public selected: boolean;
    public facturaId: number;
    public rfc: string;
    public correoElectronico: string;
    public facturaEnviada: number;
}
@Injectable()
export class BuscaCobrosInput {
    public folio: string;
    public cuentaAgua: string;
    public fechaIn: Date;
    public fechaFin: Date;
    public condicion: string;
    public idCajero: number;
    public numSolicitud: number;
    public derivada: number;
}

@Injectable()
export class FacturaMasiva {
    public id_cobro = [];
}



@Injectable()
export class GeneraRutas {
    public id: number;
    public idAgua: number;
    public idAguaZona: number;
    public idColonia: number;
    public idUsuarioLecturista: string;
    public fechaAlta: Date;
    public idTipoUso: number;
    public consecutivo: number;
    public cuentaAgua: number;
    public colonia: string;
    public tipoUso: string;
    public nombreLocal: string;
    public select?: boolean;

}
@Injectable()
export class GeneraRutasInput {
    public zona: number;
    public anioIn: number;
    public periodo: number;
    public idColonia: number;
}

@Injectable()
export class DatosCartoweb {
    public idAgua: number;
    public cuentaPredial: number;
    public tpPredial: string;
    public cveCatastral: string;
    public usuario: string;
    public contra: string;
    public url: string;
}

@Injectable()
export class DatosCartowebInput {
    public idAgua: number;
}

@Injectable()
export class GuardaFacturas {
    public _idFactura: number;
    public _tipoRecibo: number;
}

@Injectable()
export class DatosFacturacionCaja {
    public solicitante: string;
    public rfcSolicitante: string;
    public emailSolicitante: string;
    public idMedioPago: number;
    public idRegimenFiscal: number;
    public cp: number;
    public idAgua: number;
}

@Injectable()
export class CancelaCobros {
    public idCobro: number;
    public usuarioCancela: string;
    public contrasenia: string;
    public idMotivoCancelacion: number;
    public observaciones: string;
    public conceptoCancelar: number;
    public selloCancelacion: string;
    public cancelar: boolean;
    public numRow: number;
}

@Injectable()
export class CancelaCobrosInput {
    public idCobro: number;
    public xml: string;
    public uuid: string;
    public folio: number;
    public serie: string;
    public error: boolean;
    public errorDesc: string;
    public numeroError: string;
}

@Injectable()
export class CatMotivoCancelaciones {
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public descripcion: string;
    public numRow: number;
}

@Injectable()
export class ConsultaLecturasInput {
    public ruta: number;
    public anioIn: number;
    public periodo: number;
    public lecturista: number;
    public idAgua: string;
    public estatus: number;
    public id_usuario: number;
    public colonia: number;
    public fechafac: Date;
    public fechavence: Date;
    public avisoDirec: boolean;
    public rutaDesc: string;
    public cuentaAgua: number;
    public fechaemisi: Date;
    public parametrosAdicionales: string = null;
    public _reimpresion_recibo?: boolean;
}
@Injectable()
export class ConsultaLecturas {
    public numRow: number;
    public id: number;
    public consecutivo: number;
    public colonia: string;
    public direccion: string;
    public cliente: string;
    public cuenta: number;
    public lecturaFin: number;
    public lecturaIni: number;
    public anomalia: string;
    public idAnomalia: number;
    public baja: boolean = false;
    public cambio: boolean = false;
    public serie: string;
    public idDiametroToma: number;
    public idTipoPeriodo: number;
    public tipoUso: string;
    public idTipoUso: number;
    public uso: string;
    public idUso: number;
    public tipoIngreso: string;
    public idTipoIngreso: number;
    public anio: number;
    public periodoParcialidad: number;
    public observaciones: string;
    public usuarioLecturista: string;
    public idUsuarioLecturista: number;
    public idCobroConcepto: number;
    public consumo: number;
    public idAgua: number;
    public estatus: string;
    public idEstatus: number;
    public idCargo: number;
    public baseConsumo: number;
    public idBaseIva: number;
    public baseIva: number;
    public idDrenaje: number;
    public drenaje: number;
    public idDrenajeIva: number;
    public drenajeIva: number;
    public idManejo: number;
    public manejo: number;
    public idManejoIva: number;
    public manejoIva: number;
    public idActualizacion: number;
    public actualizacion: number;
    public idRecargos: number;
    public tipoServicio: string;
    public idTipoServicio: number;
    public recargos: number;
    public cargoPendiente: number;
    public idRedondeo: number;
    public redondeo: number;
    public total: number;
    public descuento: number;
    public idMedidor: number;
    public derivada: number;
    public consumoAnt: number;
    public consumoPu: number;
    public consumoPr: number;
    public consumoMin: number;
    public consumoPerAnioAnt: number;
    public fechaLecturaOutput: string;
    public fechaLectura: Date;
    public m3Original: number;
    public validacion: string;
    public fechaCritica: Date;
    public lecturaCritica: number;
    public ap_c: boolean
    public datoJson: string;
    public suma: number;
    public cargosJson: string;
    public nombreLocal: string;
    public check: boolean = false;
    public observacionText: string;
    public abono: number;
    public fechaCobro: string;
    public validadoFacturacion: string = null;
    public fechaemisi: Date;
    public fechavence: Date;
    public idEstatusAgua: number;
    public checkCargos: boolean = false;
    public idObservaciones: number;
    public observacionCatalogo: string;
    public idTipoBloqueo: number;
    public medidorDiasTrabajo: number;
    public diasPeriodo: number;
    public fechaEnvio : Date;
    public fechaImpresion : Date;
    public idUsuarioEnvio : number;
    public idUsuarioImprimio : number;
}
@Injectable()
export class CatAnomalias {
    public id: number;
    public descripcion: string;
    public dato : string;
    cambio: boolean;
    baja: any;
    public abreviatura: string;
    public numRow: number;
}

@Injectable()
export class Consumos {
    public id: number;
    public idMedidor: number;
    public lecturaIni: number;
    public lecturaFin: number;
    public consumo: number;
    public idTipoConsumo: number;
    public idDiametroToma: number;
    public idUsuarioCaptura: number;
    public fechaAlta: Date;
    public idTipoPeriodo: number;
    public anio: number;
    public periodoIni: Date;
    public periodoParcialidad: number;
    public periodoFin: Date;
    public idTipoIngreso: number;
    public idUsuarioLecturista: number;
    public observaciones: string;
    public idCargo: number;
    public idAgua: number;
    public idTipoUso: number;
    public idTipoServicio: number;
    public idCobroConcepto: number;
    public idAnomalia: number;
    public idEstatus: number;
    public idUsuarioAsigno: number;
    public fechaAsignacion: Date;
}
@Injectable()
export class CatTipoIngreso {
    public id: number;
    public descripcion: string;
    cambio: boolean;
    baja: any;
    public numRow: number;
}

@Injectable()
export class CobroConceptos {
    public id: number;
    public idCobro: number;
    public cantidad: number;
    public monto: number;
    public idCobroConceptoPadre: number;
    public idTipoPeriodo: number;
    public anio: number;
    public periodoIni: Date;
    public periodoParcialidad: number;
    public periodoFin: Date;
    public idConcepto: number;
}

@Injectable()
export class Cargos {
    public id: number;
    public idCargoPadre: number;
    public idAgua: number;
    public idConcepto: number;
    public idTipoPeriodo: number;
    public anio: number;
    public periodoIni: Date;
    public periodoParcialidad: number;
    public periodoFin: Date;
    public monto: number;
    public idUsuarioGuardo: number;
    public fechaGuardo: Date;
    public fechaVencimiento: Date;
    public idEstatus: number;
    public fechaCobro: Date;
    public idCobroConcepto: number;
    public fijar: boolean;
    public idFiscalizacion: number;
}

@Injectable()
export class ObtenerUsuarioPorCargoInput {
    public idCargo: number;
    public idEstatus: number;
}

@Injectable()
export class ObtenerUsuarioPorCargo {
    [x: string]: any;
    public id: number;
    public nombre: string;
    public nombreUsuario: string;
    public cargo: string;
    public departamento: string;
    public direccion: string;
    public idSucursal: string;
}
@Injectable()
export class EjecucionFiscalInformacion {
    public idAgua: number;
    public cuentaAgua: number;
    public nombreCompleto: string;
    public domicilio: string;
    public cp: string;
    public ruta: number;
    public numeroMedidor: string;
    public fechaInstalacion: Date;
    public claveCatastral: string;
    public rfc: string;
    public periodo: number;
    public tipoPeriodo: string;
    public anio: number;
    public fechaVencimiento: Date;
    public derivada: number;
    public anomalia: string;
    public observaciones: string;
    public diametro: string;
    public tipoServicio: string;
    public proximaLectura: string;
    public tipoUso: string;
    public lecturaIni: number;
    public lecturaFin: number;
    public periodoConsumoIni: Date;
    public periodoConsumoFin: Date;
    public consumo: number;
}
@Injectable()
export class EjecucionFiscalInformacionInput {
    public cuentaAguaDesde: number;
    public cuentaAguaHasta: number;
    public nombre: string;
    public ruta: number;
}
@Injectable()
export class json_lecturas {
    public ConsultaLecturas = new Array<ConsultaLecturas>();
    public AplicaSimulacion: Boolean;
    public id_usuario: number;
    public aplica_critica: Boolean;
    public observacion_masiva: string;
}

@Injectable()
export class json_lecturas_cargos {
    public ConsultaLecturasId: string;
    public CargosDetalles: string;
    public id_usuario: number;
}

@Injectable()
export class CatCargos {
    public id: number;
    public descripcion: string;
    public baja: boolean = false;
    public cambio: boolean = false;
    public numRow: number;
}

@Injectable()
export class PadronAguaGeneralesInput {
    public idAgua: number;
    public cuentaAguaDesde: number;
    public cuentaAguaHasta: number;
    public nombre: string;
    public ruta: number;
    public idUsuario: number;
    public idColonia: number;
    public ultAnioPag: number;
    public ultPeriodoPag: number;
    public rangoMontoIni: number;
    public rangoMontoFin: number;
    public idTipoToma: number;
    public idTipoUso: number;
    public fechaVencimientoIni: Date;
    public fechaVencimientoFin: Date;
    public periodosVencidos: number;
    public fechaInicioBloqueo: Date;
    public fechaFinBloqueo: Date;
}
@Injectable()
export class PadronAguaGenerales {
    public baja: boolean = false;
    public cambio: boolean = false;
    public idEstatusFis: number;
    public idTipoDocumento: number;
    public estatusFiscalizacion: string;
    public idEstatusCon: number;
    public idAgua: number;
    public cuentaAgua: number;
    public nombreCompleto: string;
    public domicilio: string;
    public colonia: string;
    public rfc: string;
    public cp: string;
    public ruta: number;
    public numeroMedidor: string;
    public derivada: number;
    public claveCatastral: string;
    public fechaAlta: Date;
    public tipoPeriodo: string;
    public tipoBloqueo: string;
    public tipoToma: string;
    public estatusCuenta: string;
    public tipoGrupoVulnerable: string;
    public diametro: string;
    public tipoServicio: string;
    public tipoUso: string;
    public anioDesde: number;
    public anioHasta: number;
    public periodoDesde: string;
    public periodoHasta: string;
    public base: number;
    public ivaTotal: number;
    public drenaje: number;
    public manejo: number;
    public actualizacion: number;
    public recargos: number;
    public multasVigente: number;
    public gastosVigente: number;
    public importe: number;
    public descuento: number;
    public redondeoRezago: number;
    public redondeo: number;
    public total: number;
    public calculoMulta: number;
    public calculoGastos: number;
    public totalMultasGastos: number;
    public ultimoBimFactuarado: string;
    public selected: boolean;
    public anomalia: boolean;
    public acumulado: boolean;
    public noNotificacion: boolean;
    public entrecalle1descripcion: string;
    public entrecalle2descripcion: string;
    public delegaciondescripcion: string;
    public calleprincipal: string;
    public fechaInicioBloqueo: Date;
    public fechaFinBloqueo: Date;
    public otrosCargo: number;
    public convenio: number;
    public interesCon: number;
    public interesMoraCon: number;
}
@Injectable()
export class CatVencimientos {
    public anio: string;
    public periodo: string;
    public numRow: number;
}

@Injectable()
export class CatVencimientos_ {
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public idAguaZona: number;
    public idTipoPeriodo: number;
    public anio: number;
    public periodoParcialidad: number;
    public tomaLecturaIni: Date;
    public tomaLecturaFin: Date;
    public capturaIni: Date;
    public capturaFin: Date;
    public impresionIni: Date;
    public impresionFin: Date;
    public facturacionIni: Date;
    public facturacionFin: Date;
    public entregaIni: Date;
    public entregaFin: Date;
    public fechaVencimiento: Date;
    public fecha: Date;
    public numRow: number;
}

@Injectable()
export class CatVencimientosInput {
    public _zona: string;
    public _anio: string;
    public _idPeriodo: number;
}

@Injectable()
export class AsignaLecturistasInput {
    public idAguaZona: number;
    public anio: number;
    public periodoParcialidad: number;
    public idUsuarioAsigno: number;
    public idUsuarioLecturista: number;
    public jsonCuentas = new Array<cuentas>();
    public idColonia: number;
}
@Injectable()
export class cuentas {
    public id: number;
}

@Injectable()
export class AsignaLecturistas {
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public lecturista: string;
    public idUsuario: number;
    public cuentas: number;
    public fechaAsignacion: Date;
}
@Injectable()
export class CatDescuentos {
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public idConcepto: number;
    public idConceptoAfecta: number;
    public idTipoUso: number;
    public factorDescuento: number;
    public idTipoPeriodo: number;
    public anioIni: number;
    public periodoParcialidadIni: number;
    public anioFin: number;
    public periodoParcialidadFin: number;
    public vigenciaIni: Date;
    public vigenciaFin: Date;
    public esCumplido: boolean;
    public fecha: Date;
    public numRow: number;
}

@Injectable()
export class CatTipoServiciosGrid {
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public descripcion: string;
    public abreviatuta: string;
    public numRow: number;
}
@Injectable()
export class CatGrupoConceptos {
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public descripcion: string;
    public idEstatus: number;
    public idDireccion: number;
    public idDepartamento: number;
    public numRow: number;
}
@Injectable()
export class CatDirecciones {
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public descripcion: string;
    public idPadre: number;
    public numRow: number;
}
@Injectable()
export class CatDepartamentos {
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public descripcion: string;
    public idDireccion: number;
    public numRow: number;
}
@Injectable()
export class CatConceptosGrid {
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public descripcion: string;
    public cuentaContable: number;
    public idGrupoConcepto: number;
    public idEstatus: number;
    public observaciones: string;
    public solicitable: boolean;
    public fechaIni: Date;
    public fechaFin: Date;
    public orden: number;
    public numRow: number;
}
@Injectable()
export class BuscaAsignacionesInput {
    public idAguaZona: number;
    public anio: number;
    public periodoParcialidad: number;
    public idUsuarioLecturista: number;
    public idColonia: number;
}
@Injectable()
export class BuscaAsignaciones {
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public lecturista: string;
    public idUsuario: number;
    public cuentas: number;
    public fechaAsignacion: Date;
}
@Injectable()
export class CatAnomaliasGrid {
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public descripcion: string;
    public numRow: number;
}
@Injectable()
export class CatSucursalesGrid {
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public descripcion: string;
    public numRow: number;
}
@Injectable()
export class CatCalendario {
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public fecha: Date;
    public habil: boolean;
    public numRow: number;
}
@Injectable()
export class CatTipoTomas_ {
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public descripcion: string;
    public numRow: number;
    public abreviatura: string;
}
@Injectable()
export class CatTipoDocumentosGrid {
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public descripcion: string;
    public numRow: number;
}
@Injectable()
export class CatTipoIngresoGrid {
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public descripcion: string;
    public numRow: number;
}

@Injectable()
export class CatTipoLevantamientos {
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public descripcion: string;
    public numRow: number;
}

@Injectable()
export class CatTipoDocumentos {
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public descripcion: string;
    public numRow: number;
    public idGrupoDoc: number;
}
@Injectable()
export class CatUnidadMedidas {
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public descripcion: string;
    public numRow: number;
}
@Injectable()
export class CatUnidadCobros {
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public descripcion: string;
    public numRow: number;
}

@Injectable()
export class CatAtributoInmuebles {
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public idCategoriaAtributos: number;
    public descripcion: string;
    public reqCapacidad: boolean;
    public numRow: number;
}
@Injectable()
export class CatCategoriaAtributos {
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public descripcion: string;
    public numRow: number;
}
@Injectable()
export class CatConsumoTarifas {
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public idTipoServicio: number;
    public idTipoPeriodo: number;
    public idTipoUso: number;
    public idTipoConsumo: number;
    public idDiametroTomaIni: number;
    public idDiametroTomaFin: number;
    public consumoIni: number;
    public consumoFin: number;
    public cuota: number;
    public cuotaUnidadAdicional: number;
    public numRow: number;
}
@Injectable()
export class CatFundamentosLegales {
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public descripcion: string;
    public numRow: number;
}
@Injectable()
export class CatInpcs {
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public periodo: Date;
    public inpc: number;
    public fechaCaptura: Date;
    public numRow: number;
}
@Injectable()
export class CatMarcaMedidores {
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public descripcion: string;
    public numRow: number;
}
@Injectable()
export class GeneraFiscalizacionesInput {
    public idAgua = [];
    public idUsuario: number;
    public idTipoDucumento: number;
    public idTipoToma: number;
    public idTipoUso: number;
}
@Injectable()
export class CancelaFiscalizacionesInput {
    public idAgua = [];
    public idUsuario: number;
    public idTipoDucumento: number;
}
@Injectable()
export class AplicaFiscalizacionesInput {
    public idAgua = [];
    public idUsuario: number;
    public idTipoDucumento: number;
}
@Injectable()
export class GeneraFiscalizaciones {
    public baja: boolean = false;
    public cambio: boolean = false;
}
@Injectable()
export class CancelaFiscalizaciones {
    public baja: boolean = false;
    public cambio: boolean = false;
}
@Injectable()
export class AplicaFiscalizaciones {
    public baja: boolean = false;
    public cambio: boolean = false;
}
@Injectable()
export class CatMotivoLevantamientos {
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public descripcion: string;
    public numRow: number;
}
@Injectable()
export class CatRoles {
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public descripcion: string;
    public numRow: number;
}
@Injectable()
export class CatTipoBloqueos {
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public descripcion: string;
    public numRow: number;
}
@Injectable()
export class CatTipoComprobantes {
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public descripcion: string;
    public numRow: number;
}

@Injectable()
export class CatTipoUsos {
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public descripcion: string;
    public abreviatura: string;
    public dato: string;
    public numRow: number;
}

@Injectable()
export class CatEstados {
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public descripcion: string;
    public numRow: number;
}

@Injectable()
export class Convenios {
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public idAgua: number;
    public idUsuarioGenero: number;
    public numConvenio: number;
    public idEstatus: number;
    public tasaInteres: number;
    public idTipoPeriodo: number;
    public datosGenerales = new Array<ConveniosChild>();
    public detalle = new Array<CalculoParcialidadesConvenios>();
}

@Injectable()
export class ConveniosChild {
    monto: number;
    cobroInicial: number;
    fechaCobroInicial: Date;
    fechaConvenio: Date;
    observaciones: string;
    numConvenio: number;
    numPagos: number;
    foliodoc: string;
    tasaInteres: number;
    doc: string[];
    tipoUso: string;
}
@Injectable()
export class CalculoParcialidadesConvenios {
    public id: number;
    public pago: number;
    public fechaPago: Date;
    public saldoInicial: number;
    public suertePrincipal: number;
    public precio: number;
    public interes: number;
    public iva: number;
    public montoPagoMensual: number;
    public saldoInsoluto: number;
}

@Injectable()
export class CalculoParcialidadesConveniosInput {
    public idAgua: number;
    public idSolicitud: number;
    public fechaPrimerPago: Date;
    public acumulado: number;
    public noPagos: number;
    public anticipo: number;
}
@Injectable()
export class AguaBloqueos {
    public observaciones: string;
    public baja: boolean = false;
    public cambio: boolean = false;
    public bloqueo: boolean = false;
    public id: number;
    public idTipoBloqueo: number;
    public idAgua: number;
    public idUsuarioBloqueo: number;
    public idEstatus: number;
    public fechaIni: Date;
    public fechaFin: Date;
}

@Injectable()
export class AguaDescuentos {
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public idConcepto: number;
    public idAgua: number;
    public vigenciaIni: Date;
    public vigenciaFin: Date;
    public idRequisito: number[]; // Asegúrate de que esta propiedad sea un array de números
    public observaciones: string;
    public nomina: string;
    public idUsuario: number;
    public numRow: number;
}

@Injectable()
export class AplicarConvenio {
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public numConvenio: number;
}
@Injectable()
export class AplicarConvenioInput {
    public idAgua: number;
    public idSolicitud: number;
    public acumulado: number;
    public idTipoPeriodo: number;
    public idUsuarioRealizaConvenio: number;
    public anticipo: number;
    public noPagos: number;
    public datosgenerales = new Array<ConveniosChild>();
    public detalle = new Array<CalculoParcialidadesConveniosTiie>();
}
@Injectable()
export class ImprimirDocumentosFiscalizacionInput {
    public idAgua: number;
    public idTipoDocumento: number;
}

@Injectable()
export class BuscaConvenios {
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public documento: string;
    public folioDelDocumento: string;
    public montoRestante: string;
    public numpagos: string;
    public cobroinicial: string;
    public fechaconvenio: Date;
    public observaciones: string;
    public fechacobroinicial: Date;
    public numConvenio: number;
    public idConvenio: number;
    public usuarioGenero: string;
    public tasaInteres: number;
    public detalle: string;
}
@Injectable()
export class BuscaConveniosInput {
    public idConvenio: number;
    public numConvenio: number;
    public idAgua: number;
    public idSolicitud: number;
}
@Injectable()
export class EnviarCorreo {
    public idFactura: number;
    public correo: string;
    public correocopia: string;
    public contrasenia: string;
    public enviosFactura: boolean;
}

@Injectable()
export class ServiciosConsultasInput {
    public idSolicitud: number;
    public idAgua: number;
}

@Injectable()
export class ServiciosConsultas {
    public baja: boolean = false;
    public cambio: boolean = false;
    public esEditable: boolean = false;
    public agregaCuenta: boolean = false;
    public id: number;
    public idSolicitud: number;
    public idConcepto: number;
    public descripcion: string;
    public costo: number = 0;
    public cantidad: number = 1;
    public precio: number = 0;
    public iva: number = 0;
    public monto: number = 0;
    public idConceptoCosto: number;
    public idCobroConcepto: number;
    public cuentaAgua: number;
    public idAgua: number;
    public noAdeudo: boolean;
    public esApertura: boolean;
    public noEditable: boolean = false;
    public terminoEditar: boolean = false;
    
}

@Injectable()
export class ServiciosCalculos {
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number = 0;
    public value: number;
    public label: string;
    public detalle: string;
    public costo: number = 0;
    public cantidad: number = 0;
    public precio: number = 0;
    public iva: number = 0;
    public monto: number = 0;
    public idConceptoCosto: number;
    public reqContrato: boolean;
    public noAdeudo: boolean;
    public noEditable: boolean;
}

@Injectable()
export class ServiciosCalculosInput {
    public idConcepto: number;
    public cantidad: number;
    public MontoEditable: number;
    public idGrupoConcepto: number;
}

@Injectable()
export class ServiciosCalculosTotales {
    public precio: number = 0;
    public iva: number = 0;
    public monto: number = 0;
}

@Injectable()
export class SolicitudesJson {
    public solicitudes = new Solicitudes();
    public solicitudDetalles = new Array<SolicitudDetalles>();
    public solicitudRequisitos = new Array<SolicitudRequisitos>();
    public solicitudEtapaTramites =  new Array<SolicitudEtapaTramites>();
}

@Injectable()
export class Privilegios {
    public numRow: number;
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public idModulo: number;
    public descripcion: string;
    public path: string;
    public orden: number;
    public uuid: string;
}


@Injectable()
export class CatNivelSeguridades {
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public descripcion: string;
    public numRow: number;
}

@Injectable()
export class CatModulos {
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public descripcion: string;
    public path: string;
    public orden: number;
    public numRow: number;
}

@Injectable()
export class RConceptosEtapasTramites {
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public idConcepto: number;
    public idEtapaTramite: number;
    public idEtapaTramiteSiguiente: number;
    public inicio: boolean;
    public numRow: number;

}
@Injectable()
export class FlujoTramitesInput {
    public idSolicitudDetalle: number;
    public inicio: boolean;
    public idUsuario: number;
    public idEstatus: number;
    public observaciones: string;
    public idEtapaTramite: number;
    public regresaFlujo: boolean;
}
@Injectable()
export class FGetPrivilegesInput {
    public pIdModulo: number;
    public pIdRol: number;
    public pIdPrivilegio: number;
}
@Injectable()
export class FGetPrivileges {

    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public id_rol: number;
    public rol: string;
    public id_modulo: number;
    public modulo: string;
    public id_privilegio: number;
    public privilegio: string;
    public asignado: boolean;
}

@Injectable()
export class RUsuarioNiveles {
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public idUsuario: number;
    public idNivelSeguridad: number;
    public idPrivilegio: number;
}


@Injectable()
export class FGetRoles {
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public idUsuario: number;
    public nombreUsuario: string;
    public idRol: number;
    public rol: string;
    public asignado: boolean;
}
@Injectable()
export class FGetRolesInput {
    public pIdUsuario: number;
    public pIdRol: number;
}
@Injectable()
export class RegistroBitacoraInput {
    public idUsuario: number;
    public idAgua: number;
    public accion: string;
    public idMovAsegurar: number;
    public idBitacora: number;
    public idSolicitudDetalle: number;
    id: string;
    public idConcepto: number;
    public movimiento: string;
}
@Injectable()
export class FileUpload {
    public id_banco: number;
    public FileBase64: string;
}
@Injectable()
export class FileUploadOut {
    public cuentaAgua: string;
    public idAgua: string;
    public fecha: string;
    public hora: string;
    public importe: string;
    public tipocuenta: string;
    public anio: string;
    public periodoParcialidad: string;
    public idTipoPeriodo: string;
    public tipoPago: string;
    public _con_cargo: boolean;
    public _con_convenio: boolean;
    public id_medio_pago: number;
    public id_banco: number;
    public id_usuario_cobro: number;
    public _con_estimando: boolean;
    public estatus: string;
    public id_factura: number;
}
@Injectable()
export class PagoConciliacionesInput {
    public Pagoconciliacion: string;
}
@Injectable()
export class PagoConciliaciones {
    public IdFactura: number;
    public TipoRecibo: number;
    public estatus: string;
}
@Injectable()
export class PayCard {
    public cuentaAgua: number;
    public idAgua: number;  
    public idUsuarioCobro: number;
    public anio: number;
    public bimestre: number;
    public monto: string;
    public idConceptoGeneral: number;
    public idBanco: number;
    public idMedioPago: number;
    public referencia: string;
    public fechaDeposito: Date;
    public autorizacionTarjeta: string;
    public idsCargo: string;
    public receptor: PersonaClientes;
    public idUsoCfdi: number;
    public tipoPeriodo: number;
    public esconsumo: boolean;
    public conanomalias: boolean;
    public estimado: boolean;
    public montoSinRedondeo: number;
}

@Injectable()
export class Config {
    //public AmbienteProduccion: boolean;
    public IdAmbiente: number;
    public urlAPI: string;
    public urlCarto: string;
    //public baseUrlApiWeb_Produccion: string;
    //public baseUrlApiWeb_Capacitacion: string;
}

@Injectable()
export class BuscaBitacora {
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public idAgua: number;
    public cuentaAgua: number;
    public derivada: number;
    public usario: string;
    public privilegio: string;
    public fecha: Date;
    public accion: string;
    public concepto: string;
    public ip: string;
    public movimiento: string;
}

@Injectable()
export class BuscaBitacoraInput {
    public idAgua: number;
    public cuentaAgua: number;
    public cuentaAguaFin: number;
    public fechaIn: Date;
    public fechaFin: Date;
    public idUsuario: number;
    public numSolicitud: number;
    public privilegio: number;
    public concepto: number;
}


@Injectable()
export class ConsultaBitacoraInput {
    public cuentaAgua: number;
    public fechaIn: Date;
    public fechaFin: Date;
}

@Injectable()
export class ConsultaBitacora {
    public numRow: number;
    public baja: boolean = false;
    public cambio: boolean = false;
    public cp: string;
    public rfc: string;
    public base: string;
    public ruta: string;
    public total: string;
    public manejo: string;
    public colonia: string;
    public drenaje: string;
    public importe: string;
    public recargos: string;
    public redondeo: string;
    public tipoUso: string;
    public descuento: string;
    public domicilio: string;
    public ivaTotal: string;
    public tipoToma: string;
    public anioDesde: string;
    public anioHasta: string;
    public fechaAlta: string;
    public cuentaAgua: string;
    public tipoBloqueo: string;
    public tipoPeriodo: string;
    public actualizacion: string;
    public calculoMulta: string;
    public periodoDesde: string;
    public periodoHasta: string;
    public tipoServicio: string;
    public calculoGastos: string;
    public estatusCuenta: string;
    public gastosVigente: string;
    public multasVigente: string;
    public numeroMedidor: string;
    public claveCatastral: string;
    public nombreCompleto: string;
    public redondeoRezago: string;
    public totalMultasGastos: string;
    public estatusFiscalizacion: string;
    public tipoGrupoVulnerable: string;
    public ultimoBimFactuarado: string;
}

@Injectable()
export class RUsuariosRoles {
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public idUsuario: number;
    public idRol: number;
    public numRow: number;
}

@Injectable()
export class BuscaLecturistaInput {
    public idAguaZona: number;
    public anio: number;
    public periodoParcialidad: number;
    public idUsuarioLecturista: number;
    public idColonia: number;
}

@Injectable()
export class BuscaLecturista {
    public baja: boolean = false;
    public cambio: boolean = false;
    public idConsumo: number;
    public id: number;
    public cveLocalizacion: string;
    public colonia: string;
    public domicilio: string;
    public calle: string;
    public usuario: string;
    public cveCatstral: string;
    public cuentaAgua: number;
    public noSerieMed: string;
    public uso: string;
    public lectura: string;
    public ubicacion: string;
    public giro: string;
}
@Injectable()
export class EditaLecturistaInput {
    public idConsumosIn: string;
    public idLecturistasIn: string;
}
@Injectable()
export class EditaLecturista {

}
@Injectable()
export class ContratosAltaPruebaInput {
    public idAgua: number;
    public idSolicitud: string;
    public idUsuario: number;
    public aniosCalculados: number;
}
@Injectable()
export class CertificadoNoAdeudoInput {
    public idAgua: number;
    public cuentaAgua: number;
    public cuentaAguaAnterior: string;
    public cuentaPredial: string;
    public idUsuario: number;
    public idSolicitudDetalle: number;
}
@Injectable()
export class HistoricoConsumosCanceladosInput {
    public idAgua: number;
}

@Injectable()
export class HistoricoConsumosCancelados {
    public numRow: number;
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public idAgua: number;
    public cuentaAgua: number;
    public derivada: number;
    public lecturaFin: number;
    public lecturaIni: number;
    public consumo: number;
    public anio: number;
    public periodoParcialidad: number;
    public observaciones: string;
    public tipoUso: string;
    public tipoServicio: string;
    public usuario: string;
}
@Injectable()
export class CalculoCargosAguasInput {
    public idAguasJson: string;
    public idAgua: number;
    public cuentaAgua: number;
    public colonia: number;
    public idUsuarioGuardo: number;
    public actualizaCargos: boolean;
    public fechaCalculos: Date;
    public idEstatus: number;
    public conEstimadoAnual: boolean;
    public idRuta: number;
    public fechaEmision: Date;
    public fechaVencimiento: Date;
    public periodo: number;
    public anio: number;
    public fechaFacturacion: Date;
    public limit?: number;
    public offset?: number;
    public aplicaSf?: boolean;
}

@Injectable()
export class GeneraPeriodoSiguienteInput {
    public idAgua: number;
}

@Injectable()
export class GeneraPeriodoSiguiente {
    public numRow: number;
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public anio: number;
    public periodoParcialidad: number;
    public anioSiguiente: number;
    public periodoParcialidadSigiente: number;
    public lecturaIni: number;
    public lecturaFin: number;
}
@Injectable()
export class Fiscalizaciones {
    public numRow: number;
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public idAgua: number;
    public folioNotificacion: number;
    public idUsuarioGenero: number;
    public fechaGenero: Date;
    public entregado: boolean;
    public idUsuarioEntrego: number;
    public fechaEntrega: Date;
    public idUsuarioCancelo: number;
    public fechaCancelo: Date;
    public domicilioCuenta: string;
    public idTipoDocumento: number;
    public idEstatus: number;
}

@Injectable()
export class ConsultaHistoricoMigradoInput {
    public cuenta: number;
    public derivada: number;
    public idAmbiente: number;
}

@Injectable()
export class ConsultaHistoricoMigrado {
    public numRow: number;
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public fecha: Date;
    public perioDePago: string;
    public periodoinicial: Date;
    public periodofinal: Date;
    public foliocobro: number;
    public serie: string;
    public importecobrado: number;
    public iva: number;
    public subtotal: number;
    public aguacorriente: string;
    public aguacorreinteDescuento: number;
    public drenajecorriente: number;
    public drenajecorrienteDescuento: number;
    public saneamientocorriente: number;
    public saneamientocorrienteDescuento: number;
    public infraestructuraCorriente: number;
    public recargos: number;
    public recargosDesc: number;
    public abonoSaldo: number;
    public otrocobros: number;
    public realizo: string;
    public oficina: string;
    public serieCfd: string;
    public folioCfd: string;
}
@Injectable()
export class ConsultaHistoricoMovimientosInput {
    public cuenta: number;
    public derivada: number;

}
@Injectable()
export class ConsultaHistoricoMovimientos {
    public id: number;
    public anio: number;
    public bimestre: number;
    public lecturaanterior: number;
    public lecturaactual: number;
    public consumo: number;
    public base: number;
    public serviciodrenaje: number;
    public manejoconduccion: number;
    public recargos: number;
    public actualizacion: number;
    public totalperiodo: number;
    public cargoredondeo: number;
    public importeperiodoredondeo: number;
    public pagado: boolean;
    public fechapago: string;
}
@Injectable()
export class CancelaSolicitudInput {
    public idSolicitud: number;
    public idUsuarioCancelo: number;
    public observaciones: string;
}
@Injectable()
export class CancelaSolicitud {
    public numRow: number;
    public baja: boolean = false;
    public cambio: boolean = false;
}

@Injectable()
export class PropietarioRAguas {
    public id: number;
    public Nombre: string;
    public PrimerApellido: string;
    public SegundoApellido: string;
    public RazonSocial: string;
    public Rfc: string;
    public CorreoElectronico: string;
}
@Injectable()
export class CatRegimenFiscal {
    public numRow: number;
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public clave: number;
    public descripcion: string;
}

@Injectable()
export class BusquedaContratos {
public id: number;
public cuentaAgua: number;
public numContrato: string;
public fecha: Date;
public idContrato: number;
public contrato: string;
}

@Injectable()
export class BusquedaContratosInput {
public cuentaAgua: string;
}

@Injectable()
export class ConsultaOrdenesTrabajo {
public numRow: number;
public baja: boolean;
public cambio: boolean;
public selected: boolean = false;
public imprimir: boolean = false;
public id: number;
public idEstatus: number;
public estatusDesc: string;
public orden: number;
public fechaAlta: Date;
public tipoOrden: string;
public idConcepto: number;
public idPersonaCliente: number;
public idPersonaPropietario: number;
public nombre: string;
public direccion: string;
public colonia: string;
public solicitante: string;
public observaciones: string;
public cveCuadrilla: string;
public medidor: string;
public telefonoOrdenes: string;
public contrato: number;
public idViaAtencion: number;
public viaAtencionDes: string;
public etapasOrdenes: EtapasOrdenes[];
public zonaOrdenes: string;
public usuario: string;
public idCalleIncidente: number;
public calleIncidente: string;
public idCalleIncidente1: number;
public calleIncidente1: string;
public idCalleIncidente2: number;
public calleIncidente2: string;
public idColoniaIncidente: number;
public coloniaIncidente: string;
public idDireccion: number;
public direccionDescripcion: string;
public idDireccionDepartamento: number;
public direccionDepartamentoDescripcion: string;
public idDireccionOficina: number;
public direccionOficinaDescripcion: string;

}

@Injectable()
export class ConsultaOrdenesTrabajoInput {
public idSolicitud: number;
public numOrdenT: number;
public cuentaAgua: number;
public idUsuario: number ;
public idEstatus: number;
public fechaAlta: string;
public fechaFin: string;
public idConcepto: string;
public solicitante: string;
public direccion: string;
public observaciones: string;
public medidor: string;
public telefonoOrdenes: string;
public zonaOrdenes: string;
public idColonia: number;
public idCalle: number;
public idCalle1: number;
public idCalle2: number;
public idDireccion: number;
public idDepartamento: number;
public idOficina: number;
public idAtencion: number;
public usuario: string;
public cveCuadrilla: string;
}

@Injectable()
export class CatViaAtencion {
public idViaAtencion: number;
public viaAtencion: string;
public idAnt: string;
}

@Injectable()
export class FdatosJson {
    public id: number;
    public renglon: string;
}

@Injectable()
export class EtapasOrdenes{
    public numRow: number;
    public baja: boolean;
    public cambio: boolean;
    public id: number;
    public numOrden: number;
    public IdDireccion: number;
    public area: string;
    public IdDireccion1: number;
    public departamento: string; 
    public IdDireccion2: number;
    public oficina: string;      
    public IdUsuarioEjecuto: number;
    public id_concepto: number;
    public usuario: string;      
    public fecha: Date;
    public IdEstatus: number;
    public estatusDesc: string; 
    public observaciones: string    
}
@Injectable()
export class CancelaConvenioInput {
public idConvenio: number;
public observaciones: string;
}
@Injectable()
export class CancelaConvenio {
public id: number;
public numRow: number;
public baja: boolean = false;
public cambio: boolean = false;
}

@Injectable()
export class HistoricoLecturas {
public numRow: number;
public baja: boolean = false;
public cambio: boolean = false;
public id: number;
public anio: number;
public numeroMes: number;
public mes: string;
public lecturaInicial: string;
public lecturaFinal: string;
public m3: string;
public val: string;
}

@Injectable()
export class HistoricoLecturasInput {
    public IdAgua: number;
    public CuentaAgua: number;
    public IdAmbiente: number;
}

@Injectable()
export class TipoCuentaContable {
public numRow: number;
public baja: boolean = false;
public cambio: boolean = false;
public descripcion: string;
public id: number;
}

@Injectable()
export class CatCuentasContables {
    public numRow: number;
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public idPadre: number;
    public cuentaCargo: number;
    public descripcion: string;
    public idTipoCuentaContable: number;
    public idEstatus: number;
    public idCuentasContables: number;
    public idCuentasCargo : number;
}

@Injectable()
export class DatosDeCobro {
    public name: string;
    public code: string;
    public icon: string;
}   

@Injectable()
export class FBuscaProrrateosInput {
    public cuentaAgua: number;
}

@Injectable()
export class FBuscaProrrateos {
    public numRow: number;
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public cuentaAgua: number;
    public derivada: number;
    public idProatero: number;
    public titular: string;
    public calle: string;
    public colonia: string;
    public numExterior: string;
    public numIneritr: string;
    public ruta: string;
    public consecutico: number;
    public uso: string;
    public estatus: string;
    public medidor: string;
    public cuentaGeneral: number;
}

@Injectable()
export class CatProrrateo {
    public numRow: number;
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public descripcion: string;
    public tipo: string;
}

@Injectable()
export class FCatVencimientosInput {
public IdAgua: number;
}

@Injectable()
export class FCatVencimientos {
public numRow: number;
public baja: boolean = false;
public cambio: boolean = false;
public id: number;
public idAguaZona: number;
public idTipoPeriodo: number;
public anio: number;
public periodoParcialidad: number;
public fechaVencimiento: Date;
public sigIdTipoPeriodo: number;
public sigAnio: number;
public sigPeriodoParcialidad: number;
public lecturaIni: number;
public lecturaFin: number;
}

@Injectable()
export class CatReportes {
    public numRow: number;
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public etiqueta: string;
    public nombreJasper: string;
    public idEstatus: string;
    public idGrupoReporte: number;
    public data: [];
}

@Injectable()
export class CatReportesInput {
    public id: number;
    public etiqueta: string;
    public nombreJasper: string;
    public idGrupoReporte: number;
    public data: [];
}

export interface ImpuntDataRepote {
    descripcion: string;
    nombre: string
    tipo: string;
    valor: string
}

@Injectable()
export class BitacoraEstadoCuentaMasivo {
    public numRow: number;
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public idBitacora: number;
    public idRuta: number;
    public periodoParcialidad: number;
    public anio: number;
    public datos: [];
}

@Injectable()
export class BitacoraEstadoCuentaMasivoInput {
    public idBitacora: number;
    public idRuta: number;
    public periodoParcialidad: number;
    public anio: number;
    public datos: [];
}

@Injectable()
export class BuscaBitacoraMasivo {
    public cuentaAgua: number;
}

@Injectable()
export class BuscaBitacoraMasivoInput {
    public cuentaAgua: number;
}

@Injectable()
export class Parametros {
    public numRow: number;
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public idConcepto: number;
    public parametro: string;
    public descripcion: string;
    public valorCaracter: string;
    public valorNumerico: number;
    public valorFecha: Date;
    public valorBool: boolean;
    public fechaVigenciaIni: Date;
    public fechaVigenciaFin: Date;
    public idParametroGrupo: number;
    public idAmbiente: number;
}
@Injectable()
export class RegistroFiscalizacionesInput {
    public idsAguas: string;
    public idUsuario: number;
    public idTipoDocumento: number;
    public idUsuarioNotificador: number;
}

@Injectable()
export class FCargosCalculosInput {
    public idConcepto: number;
    public cantidad: number;
    public costoEditado: number;
    public idGrupoConcepto: number;
    public clave: string;
}

@Injectable()
export class FCargosCalculos {
    public numRow: number;
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public value: number;
    public label: string;
    public detalle: string;
    public costo: number;
    public cantidad: number;
    public precio: number;
    public iva: number;
    public monto: number;
    public idConceptoCosto: number;
    public reqContrato: boolean;
    public noAdeudo: boolean;
    
}


@Injectable()
export class PadObservaciones {
    public numRow: number;
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public idAgua: number;
    public observacion: string;
    public idUsuario: number;
    public fecha: Date;
    public nombreUsuario: string;
    public hora: string;
}
// cat delegaciones
@Injectable()
export class CatDelegaciones {
    public numRow: number;
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public descripcion: string;
    public idMunicipio: number;
}
@Injectable()
export class AguaBuscaCuentasInput {
public cuentaAguaAnterior: string;
public cuentaAgua: number;
public derivada: number;
public cuentaPredial: number;
public domicilio: string;
public colonia: string;
public cveCatastral: string;
public cveMun: number;
public cveZona: number;
public cveManz: number;
public cveLote: number;
public cveEdif: string;
public cveDepto: string;
public cliente: string;
public razonSocial: string;
public nombre: string;
public primerApellido: string;
public segundoApellido: string;
public serie: string;
public idTipoServicio: number;
public idTipoUso: number;
public idRuta: number;
public nombreLocal: string;
public idDelegacion: number;
public idCalle: number;
}

@Injectable()
export class AltaContratos {
public numRow: number;
public baja: boolean = false;
public cambio: boolean = false;
public id: number;
public cuentaAgua: number;
public derivada: number;
public cuentaAguaAnterior: string;
public idUsuarioGuardo: number;
public fechaAlta: Date;
public fechaBaja: Date;
public idEstatus: number;
public idAguaZona: number;
public idTipoServicio: number;
public idTipoToma: number;
public idTipoUso: number;
public idTipoConsumo: number;
public fechaUltimoPago: Date;
public idTipoPeriodoUp: number;
public periodoAnioUp: number;
public periodoParcialidadUp: number;
public porcentajeConstruccion: number;
public observaciones: string;
public idDiametroToma: number;
public fechaCorte: Date;
public cveMun: number;
public cveZona: number;
public cveLoc: number;
public cveSec: number;
public cveManz: number;
public cveLote: number;
public cveEdif: string;
public cveDepto: string;
public cuentaPredial: number;
public tpPredial: string;
public domicilio: string;
public numeroLocal: string;
public nombreLocal: string;
public idCalle: number;
public idMunicipio: number;
public idColonia: number;
public numExteror: string;
public numInterior: string;
public superficieConstruccion: number;
public idTipoGiro: number;
public esCumplido: boolean;
public cp: string;
public idSolicitudDetalle: number;
public dato: string;
public idCalleColinda1: number;
public idCalleColinda2: number;
public gpsLatitud: string;
public gpsLongitud: string;
public consecutivo: number;
public idProrrateo: number;
public idDelegacion: number;
public idTipoContrato: number;
public cveCatastral: string;
}

@Injectable()
export class AltaContratosInput {
public altaContratos: string;
}

@Injectable()
export class ActualizaAltaContratosInput {
public idSolicitud: number;
}
@Injectable()
export class ActualizaAltaContratos {
public idAgua: number;
public idTipoContrato: number;
}

@Injectable()
export class Remesas {
public numRow: number;
public id: number;
public idUsuarioCaptura: number;
public fechaCaptura: Date;
public m1000: number;
public q500: number;
public d200: number;
public c100: number;
public c50: number;
public v20: number;
public d10: number;
public tarjetaDebito: number;
public tarjetaCredito: number;
public cheque: number;
public morralla: number;
public transferencia: number;
public totalEfectivo: number;
public totalRemesado: number;
public pagoLinea: number; 
public datosAdicionales: string;
}

@Injectable()
export class CobrosPorTipoPagoInput {
public idUsuarioCobro: number;
}
@Injectable()
export class CobrosPorTipoPago {
public numRow: number;
public baja: boolean = false;
public cambio: boolean = false;
public idUsuarioCobro: number;
public monto: number;
public medioPago: string;
}
@Injectable()
export class DetalleConvenio {
    pagado: number;
    parcialidad: number;
    iva: string;
    interes: string;
    recargos: string;
    importetotal: string;
    importeparcialidad: string;
    fecha_pago: string;
    fecha_cobro: string | null;
    num_convenio: number;
}

@Injectable()
export class CalculoParcialidadesConveniosTiie {
public id:  number;
public pago: number;
public saldoInicial: number; 
public importeNeto: number;
public interes: number;
public importePagar: number;
public saldoInsoluto: number;
public fecha: Date;
}
@Injectable()
export class CalculoParcialidadesConveniosTiieInput {
public noPagos: number;
public porcentaje: number;
public saldo: number;
public anticipo: number;
public fechaCobroInicial: Date;
}

@Injectable()
export class CatTipoObservacion {
public numRow: number;
public baja: boolean = false;
public cambio: boolean = false;
public id: number;
public descripcion: string;
}

@Injectable()
export class DatosPadron{
public fechaAltaSistema: Date;
public fechaContratoAgua: Date;
public fechaInstalacionMedidor: Date;
public contratoDrenaje: string;
public fechaContratoDrenaje: Date;
public tomaDrenaje: string;
public idDiametroTomaDrenaje: number;
}

@Injectable()
export class DatosPadronInpunt{
public idAgua: number;
}
@Injectable()
export class ConveniosHistInput {
  public idAgua: number | null = null;
  public numConvenio: number | null = null;
  public desde: Date;
  public hasta: Date;
}

@Injectable()
export class ConveniosHist {
public numRow: number;
public baja: boolean = false;
public cambio: boolean = false;
public id: number;
public numConvenio: number;
public cuentaAgua: number;
public numSolicitud: number;
public usuarioGenero: string;
public estatus: string;
public monto: number;
public fechaConvenio: Date;
public numPagos: number;
public observaciones: string;
}
@Injectable()
export class CatTiie {
public numRow: number;
public baja: boolean = false;
public cambio: boolean = false;
public id: number;
public fecha: Date;
public tasa: number;
}
@Injectable()
export class ConceptosAdicionalesInput {
public idConceptoPrincipal: number;
}
@Injectable()
export class ConceptosAdicionales {
public id: number;
}
@Injectable()
export class ProximaAsignacion {
    public anio: number;
    public periodoParcialidad: number;
}
@Injectable()
export class ProximaAsignacionInput {
    public idAguaZona: number;
    public actual:boolean = false;
}


@Injectable()
export class RConceptosDirecciones {
    public numRow: number;
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public idConcepto: number;
    public idDireccion: number;
}

@Injectable()
export class Domiciliacion {
public numRow: number;
public baja: boolean = false;
public cambio: boolean = false;
public id: number;
public idAgua: number;
public titular: string;
public idBanco: number;
public clabe: string;
public idEstatus: number;
public fecha: Date;
public dato: string;
public idUsuario: number;
}

@Injectable()
export class FDomiciliacionInput {
public fechaIni: Date;
public fechaFin: Date;
}

@Injectable()
export class FDomiciliacion {
public numRow: number;
public baja: boolean = false;
public cambio: boolean = false;
public id: number;
public importeSinIva: number;
public iva: number;
public referenciaNumerica: number;
public titularServicio: string;
public banco: string;
public tipoCuenta: string;
public clabe: string;
public titularCuenta: string;
public txt: string;
}

@Injectable()
export class IngresoPor {
public estadoCuenta: Boolean=false;
public historicoAdeudo: boolean = false;
public Prescripcion: boolean = false;
public editarCargo: boolean = false;
public convenios: boolean = false;
public caja: boolean = false;
}
@Injectable()
export class CargosDetallesRequest {
    public cargosDetalles: CargosDetalles[]= [];
    public bitacora: string = '';
    public flagPreCalculo: boolean = false;
}
export class CatMotivosCancelacionCfdi {
public numRow: number;
public baja: boolean = false;
public cambio: boolean = false;
public id: number;
public clave: string;
public descripcion: string;
}
@Injectable()
export class RRequisitosDescuentos {
public id: number;
public idRequisito?: number;
public idDescuento?: number;
 }
@Injectable()
export class WizpokIntentoPagoRequest {
public concept:string;
public amount:number;
public customer:string;
public idAgua:string;
public cuentaAgua:string;
public arrCargos:string;


}
@Injectable()
export class RAguasPersonasClientes {
public numRow: number;
public baja: boolean = false;
public cambio: boolean = false;
public id: number;
public idAgua: number;
public idPersona: number;
}

@Injectable()
export class CuentasByPersona{
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public cuentaAgua: number;
    public idPersona: number;
    public numRow: number;
}

@Injectable()
export class GuardaFoliosOrdenes {
public numRow: number;
public baja: boolean = false;
public cambio: boolean = false;
public id: number;
public jsonGuarda: string;
}

@Injectable()
export class FCuentasEnvioMasivoRecibosInput {
public idRuta: number;
public cuentaAgua: number;
public anio: number;
public periodoParcialidad: number;
}

@Injectable()
export class FCuentasEnvioMasivoRecibos {
public check: boolean = false;
public numRow: number;
public baja: boolean = false;
public cambio: boolean = false;
public idAgua: number;
public cuentaAgua: number;
public correoElectronico1: string;
public correoElectronico2: string;
public anio: number;
public periodoParcialidad: number;
public mesPeriodo: string;
public fechaVencimiento: string;
public propietario: string;
public domiciolio: string;
}

@Injectable()
export class CuentasEnvioRecibos {
    public idAgua: number;
    public cuentaAgua: number;
    public correoElectronico1: string;
    public correoElectronico2: string;
    public anio: number;
    public periodoParcialidad: number;
    public mesPeriodo: string;
    public propietario: string;
    public domiciolio: string;
}

@Injectable()
export class RegistrosCorreosEnviadosRecibos {
    public id: number;
    public idAgua: number;
    public cuentaAgua: number;
    public anio: number;
    public periodoParcialidad: number;
    public mesPeriodo: string;
    public correoElectronico1: string;
    public correoElectronico2: string;
    public fechaEnvio: Date;
    public idUsuarioEnvio: number;
}
@Injectable()
export class CalculoCargosEspecialesInput {
    public idAguasJson: number[] = [];
    public tarifa: number;
    public idUsuarioGuardo: number;
}
@Injectable()
export class CalculoCargosEspeciales {
}
@Injectable()
export class GetContratos {
public numRow: number;
public baja: boolean = false;
public cambio: boolean = false;
public id: number;
public numContrato: string;
public fecha: Date;
public idTipoContrato: number;
}
@Injectable()
export class GetContratosInput {
public idAgua: number;
}

@Injectable()
export class FGeneraBloqueoMasivoInput {
    public jsonAgua: string;
    public idUsuario: number;
    public tipoBloqueo: string;
    public idEstatus: number;
    public observacion: string;
}

@Injectable()
export class FConsultaPagosSigeinInput {
public idAgua: number;
}

@Injectable()
export class FConsultaPagosSigein {
public numRow: number;
public baja: boolean = false;
public cambio: boolean = false;
public fechaCobro: Date;
public periodoPago: string;
public folioPago: string;
public totalPago: string;
public agua: string;
public aguaDescuento: string;
public drenaje: string;
public drenajeDescuento: string;
public manejo: string;
public manejoDescuento: string;
public infraestructura: string;
public infraDescuento: string;
public recargos: string;
public cajeroPago: string;
public cajaPago: string;
public convenio: string;
public convenioIntere: string;
public otrosCargos: string;
public otrosCargosIva: string;
public baseIva: string;
public drenajeIva: string;
public manejoIva: string;
public infraIva: string;
}

@Injectable()
export class CatGrupoDocumentos {
public numRow: number;
public baja: boolean = false;
public cambio: boolean = false;
public id: number;
public descripcion: string;
}
@Injectable()
export class CatCfdiTiposRelacion {
public numRow: number;
public baja: boolean = false;
public cambio: boolean = false;
public id: number;
public codigo: string;
public descripcion: string;
}
 
@Injectable()
export class FHistoricoReconexionInput {
public idAgua: number;
}

@Injectable()
export class FHistoricoReconexion {
public numRow: number;
public baja: boolean = false;
public cambio: boolean = false;
public total: string;
public fechaPago: string;
public serie: string;
public folio: string;
public cuentaAgua: string;
public derivada: string;
public estatus: string;
public uso: string;
public usuarioEjecutor: string;
}


@Injectable()
export class Facturas {
    public numRow: number;
    public baja: boolean = false;
    public cambio: boolean = false;
    public id: number;
    public uuid: string;
    public xml: string;
    public cbb: any;
    public fechaEmision: Date;
    public serie: string;
    public folio: number;
    public fechaCancelado: Date;
    public observaciones: string;
    public idEstatus: number;
    public datosAdicionales: string;
    public idTipoComprobante: number;
}